import apiClient from "../../helpers/apiClient";
import { arrayToObject, objectToArray } from "../../helpers/utility";
import { isEmptyObj } from "../../helpers/validator";
import { createLoadingSelector } from "./Loading";

export const FETCH_SYSTEM_CODES = "FETCH_SYSTEM_CODES";
export const FETCH_SYSTEM_CODES_REQUEST = "FETCH_SYSTEM_CODES_REQUEST";
export const FETCH_SYSTEM_CODES_SUCCESS = "FETCH_SYSTEM_CODES_SUCCESS";
export const FETCH_SYSTEM_CODES_FAILURE = "FETCH_SYSTEM_CODES_FAILURE";

export const GET_ALL_NATIONALITIES = "GET_ALL_NATIONALITIES";
export const GET_ALL_NATIONALITIES_REQUEST = "GET_ALL_NATIONALITIES_REQUEST";
export const GET_ALL_NATIONALITIES_SUCCESS = "GET_ALL_NATIONALITIES_SUCCESS";
export const GET_ALL_NATIONALITIES_FAILURE = "GET_ALL_NATIONALITIES_FAILURE";

export const GET_ALL_COUNTRIES = "GET_ALL_COUNTRIES";
export const GET_ALL_COUNTRIES_REQUEST = "GET_ALL_COUNTRIES_REQUEST";
export const GET_ALL_COUNTRIES_SUCCESS = "GET_ALL_COUNTRIES_SUCCESS";
export const GET_ALL_COUNTRIES_FAILURE = "GET_ALL_COUNTRIES_FAILURE";

const initialState = {
  data: {},
  errorMessage: ""
};

export const loadingSysCodesSelector = createLoadingSelector([
  FETCH_SYSTEM_CODES
]);
export const fetchSysCodes = parentCode => dispatch => {
  return dispatch({
    types: [
      FETCH_SYSTEM_CODES_REQUEST,
      FETCH_SYSTEM_CODES_SUCCESS,
      FETCH_SYSTEM_CODES_FAILURE
    ],
    shouldCallAPI: state =>
      !loadingSysCodesSelector(state) &&
      (isEmptyObj(state.systemCode.data) || !state.systemCode.data[parentCode]),
    callAPI: config =>
      apiClient.get(`api/systemCode/getSystemCodes/${parentCode}`, config),
    payload: {}
  });
};

export const getAllNationalities = () => dispatch => {
  return dispatch({
    types: [
      GET_ALL_NATIONALITIES_REQUEST,
      GET_ALL_NATIONALITIES_SUCCESS,
      GET_ALL_NATIONALITIES_FAILURE
    ],
    callAPI: config => apiClient.get(`SystemCodes/GetAllNationalities`, config),
    payload: {}
  });
};

export const getAllCountries = () => dispatch => {
  return dispatch({
    types: [
      GET_ALL_COUNTRIES_REQUEST,
      GET_ALL_COUNTRIES_SUCCESS,
      GET_ALL_COUNTRIES_FAILURE
    ],
    callAPI: config => apiClient.get(`SystemCodes/GetAllCountries`, config),
    payload: {}
  });
};

export const getSysCodeOptions = parentCode => (dispatch, getState) => {
  return dispatch(fetchSysCodes(parentCode)).then(resp => {
    const salutations = getState().systemCode.data[parentCode];
    if (salutations) {
      const salutationOptions = objectToArray(salutations).reduce((acc, sa) => {
        acc.push({ value: sa.name, label: sa.name });
        return acc;
      }, []);
      return { options: salutationOptions };
    }
  });
};

export default function reducer(state = initialState, action) {
  const { payload, errorMessage, response } = action;
  switch (action.type) {
    case FETCH_SYSTEM_CODES_REQUEST:
      return {
        ...state,
        errorMessage: "",
        successMessage: ""
      };
    case FETCH_SYSTEM_CODES_FAILURE:
      return {
        ...state,
        errorMessage
      };
    case FETCH_SYSTEM_CODES_SUCCESS:
      const currentParentCode = state.data[payload[0].parentCode];
      return {
        ...state,
        data: {
          ...state.payload,
          [payload[0].parentCode]: {
            ...currentParentCode,
            ...arrayToObject(payload, "systemCode")
          }
        }
      };
    case GET_ALL_NATIONALITIES_SUCCESS:
      return {
        ...state,
        nationalities: response.data.result
      };
    case GET_ALL_COUNTRIES_SUCCESS:
      // console.log("nationalities1:", response.data.result);
      return {
        ...state,
        countries: response.data.result
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/SystemCode.js